/* eslint-disable camelcase */
import isBefore from 'date-fns/isBefore';
// isBefore(new Date(2010, 9, 20), new Date(2010, 9, 21));
import API from 'shared/constants/api';
import { isValidEmail, isValidPhone, isValidITN, isValidVIN } from 'shared/validations/validations';
import { getParamByKey } from 'shared/helpers/users';
import { sendOrderConfirmationCode } from 'shared/network/polis';
import { getFormattedDateFns } from 'shared/helpers/locale';

// import { setRedirectUrl } from '../actions/globals';

const DEFAULT_VALIDITY = 33;
// const DEFAULT_PERIOD = 14;
const DEFAULT_DGO = 34;

const NATURAL_OWNER_TYPE = 57; // фізособа-57
const LEGAL_OWNER_TYPE = 12; // юрособа-12 // todo move to const file

const USED_IN_TAXI = 11;
const NOT_USED_IN_TAXI = 56;

const EL_POLISE = 52;
const NATURAL_POLISE = 55;

const HAVE_PRIVILEGES = 40;
const NOT_HAVE_PRIVILEGES = 54;

const NOVA_POSHTA_DELIVERY_ID = 3;

const { hostname, protocol, port } = typeof window === 'undefined' ? {} : window.location;

const MONTH_CALCULATOR = {
  20: 1,
  21: 1,
  22: 2,
  23: 3,
  24: 4,
  25: 5,
  26: 6,
  27: 6,
  28: 7,
  29: 8,
  30: 9,
  31: 10,
  32: 11,
  33: 12,
};

const TOMORROW = new Date();
TOMORROW.setDate(new Date().getDate() + 1);

export const ByParamsValidation = {
  mapPropsToValues: data => {
    const {
      // isNumberBlock,
      selectedValues,
      filters: { transport_type: transportType, dgo, validity },
    } = data;
    return {
      transport_type:
        transportType && Array.isArray(transportType.values) ? transportType.values[0] : '',
      region: null,
      dgo: Array.isArray(dgo.values) ? dgo.values.find(item => item.id === DEFAULT_DGO) : '',
      validity: Array.isArray(validity.values)
        ? validity.values.find(item => item.id === DEFAULT_VALIDITY)
        : '',
      taxi: false,
      privileges: false,
      epolils: true,
      ...selectedValues,
    };

    // if (isNumberBlock) formFields.car_number = '';
    // else formFields.transport_type = transportType && transportType.values[0];
  },

  validate: data => {
    const { region, transport_type: transportType = '', dgo, validity } = data;
    const errors = {};

    if (!transportType) errors.transport_type = true;
    if (!region) errors.region = true;
    if (!dgo) errors.dgo = true;
    if (!validity) errors.validity = true;

    return errors;
  },

  handleSubmit: (values, { props, setSubmitting }) => {
    const { fetch } = props;

    const {
      transport_type: transportType,
      dgo,
      privileges,
      region,
      taxi,
      validity = {},
      epolils,
      owner_type: ownerType,
    } = values;

    const requestData = {
      options: {
        transport_type: transportType && transportType.id,
        dgo: dgo.id,
        region: region.id,
        validity: validity.id || DEFAULT_VALIDITY,
        is_taxy: taxi ? USED_IN_TAXI : NOT_USED_IN_TAXI,
        epolils: epolils ? EL_POLISE : NATURAL_POLISE,
        owner_type: ownerType ? LEGAL_OWNER_TYPE : NATURAL_OWNER_TYPE,
        privileges: privileges ? HAVE_PRIVILEGES : NOT_HAVE_PRIVILEGES,
      },
    };

    fetch(API.POLIS.OFFERS, {
      method: 'POST',
      'Content-Type': 'application/json',
      body: JSON.stringify(requestData),
    })
      .then(res => res.json())
      .then(result => {
        const offersRes = result.status && result.data;
        props.setOffersData(offersRes, 'by-car-parameters', values);
        setSubmitting(true);
      });
  },

  displayName: 'StaticPageForm',
};

export const ByNumbersValidation = {
  mapPropsToValues: data => {
    const {
      // isNumberBlock,
      selectedValues,
      filters: { dgo, validity },
    } = data;
    return {
      car_number: '',
      region: null,
      dgo: dgo.values.find(item => item.id === DEFAULT_DGO),
      validity: validity.values.find(item => item.id === DEFAULT_VALIDITY),
      taxi: false,
      privileges: false,
      epolils: true,
      ...selectedValues,
    };
  },

  validate: data => {
    const { region, car_number: carNumber, dgo, validity } = data;
    const errors = {};

    if (!carNumber) errors.car_number = true;
    if (!region) errors.region = true;
    if (!dgo) errors.dgo = true;
    if (!validity) errors.validity = true;

    return errors;
  },

  handleSubmit: async (values, { props, setSubmitting }) => {
    const { fetch } = props;
    props.showHideServerError(false);

    const {
      car_number: carNumber,
      dgo,
      privileges,
      region,
      taxi,
      validity = {},
      epolils,
      owner_type: ownerType,
    } = values;

    const requestData = {
      options: {
        car_number: carNumber,
        dgo: dgo.id,
        region: region.id,
        validity: validity.id || DEFAULT_VALIDITY,
        is_taxy: taxi ? USED_IN_TAXI : NOT_USED_IN_TAXI,
        epolils: epolils ? EL_POLISE : NATURAL_POLISE,
        owner_type: ownerType ? LEGAL_OWNER_TYPE : NATURAL_OWNER_TYPE,
        privileges: privileges ? HAVE_PRIVILEGES : NOT_HAVE_PRIVILEGES,
      },
    };

    const offersRes = await fetch(API.POLIS.OFFERS, {
      method: 'POST',
      'Content-Type': 'application/json',
      body: JSON.stringify(requestData),
    }) // queryString.stringify(offersQueryParams)
      .then(res => res.json())
      .then(result => {
        if (result.status && result.data) return result.data;
        return null;
      });

    if (offersRes) {
      props.setOffersData(offersRes, 'by-car-number', values);
      setSubmitting(true);
    } else props.showHideServerError(true);
  },

  displayName: 'StaticPageForm',
};

export const RegistrOsagoValidation = {
  mapPropsToValues: props => {
    const { user, selectedValues, fillsData, editOrder } = props;
    const { email, phones, name } = user;

    let defValue = {
      epolils: true,
      confirm_btn: false,
      city_registration: null,
      firstname: '',
      lastname: '',
      car_mark: null,
      car_model: null,
      date_of_birth: '',
      delivery_type: null,
      document_type: null,
      document_date: '',
      patronymic: '',
      document_serial: '',
      document_number: '',
      document_whom: '',
      inn: '',
      polis_start: '',
      car_body: '',
      address_registration: '',
      car_volume: '',
      city: null,
      phone: '',
      email: '',
      car_number: '',
      car_year: '',
      fio: '',
      point: '',
      //
      company_name: '',
      company_city: null,
      company_code: '',
      company_address: '',
      company_email: '',
      used_month: [],
    };

    if (editOrder && editOrder.data && editOrder.delivery) {
      const { data = {}, delivery } = editOrder;
      const { used_month: usedMonth } = data;
      let fixedUsedMonth = [];

      if (usedMonth && usedMonth.length) fixedUsedMonth = usedMonth.map(item => +item);

      defValue = {
        ...defValue,
        ...data,
        ...delivery,
        used_month: fixedUsedMonth,
        date_of_birth: new Date(data.date_of_birth),
        document_date: new Date(data.document_date),
        polis_start: isBefore(new Date(data.polis_start), new Date(TOMORROW))
          ? new Date(TOMORROW)
          : new Date(data.polis_start),
      };
    }

    if (selectedValues.car_number && fillsData) {
      // eslint-disable-next-line camelcase
      const {
        car_number: carNumber,
        car_year: carYear,
        car_volume: carVolume,
        car_body: carBody,
      } = fillsData;

      if (carNumber) defValue.car_number = getParamByKey(carNumber, 'value');
      if (carVolume) defValue.car_volume = getParamByKey(carVolume, 'value');
      if (carYear) defValue.car_year = new Date(getParamByKey(carYear, 'value'));
      if (carBody) defValue.car_body = getParamByKey(carBody, 'value');
    }
    if (!selectedValues.email && !editOrder) defValue.email = email;
    if (!selectedValues.firstname && !editOrder) defValue.firstname = name;
    if (
      !selectedValues.phone &&
      !selectedValues.owner_type &&
      phones &&
      phones.length &&
      !editOrder
    ) {
      const verifiedPhone = phones.find(item => item.is_verified);
      defValue.phone = verifiedPhone ? verifiedPhone.number : phones[0].number;
    }

    return defValue;
  },

  validate: (values, { intl, selectedValues }) => {
    // eslint-disable camelcase
    const errors = {};

    const isOwnerType = !!selectedValues.owner_type;
    const monthCount = MONTH_CALCULATOR[selectedValues.validity.id || DEFAULT_VALIDITY];

    const {
      used_month,
      city_registration,
      firstname,
      lastname,
      car_mark,
      car_model,
      date_of_birth,
      delivery_type,
      document_type,
      document_date,
      patronymic,
      document_serial,
      document_number,
      document_whom,
      inn,
      polis_start,
      car_body,
      address_registration,
      car_volume,
      city,
      phone,
      email,
      car_number,
      car_year,
      fio,
      point,
      //
      company_name,
      company_city,
      company_code,
      company_address,
      company_email,
      confirm_btn,
    } = values;

    const deliveryTypeId = delivery_type && +delivery_type.id;

    // driver info
    if (!isOwnerType && !firstname) errors.firstname = true;
    if (!isOwnerType && !lastname) errors.lastname = true;
    if (!isOwnerType && !patronymic) errors.patronymic = true;
    if (!isOwnerType && !date_of_birth) errors.date_of_birth = true;
    if (!isOwnerType && !document_type) errors.document_type = true;
    if (!isOwnerType && !document_date) errors.document_date = true;
    if (!isOwnerType && !document_serial) errors.document_serial = true;
    if (!isOwnerType && !document_number) errors.document_number = true;
    if (!isOwnerType && !document_whom) errors.document_whom = true;
    // driver info end
    // personal data start
    if (!isOwnerType && !isValidITN(inn))
      errors.inn = intl.formatMessage({
        id:
          'Введите корректный идентификационный код. Идентификационный код состоит из 10-ти цифр. Если у вас нет идентификационного кода введите код 0000000000',
      });
    if (!isOwnerType && !city_registration) errors.city_registration = true;
    if (!isOwnerType && !address_registration) errors.address_registration = true;
    if (!isOwnerType && !email) errors.email = true;
    else if (!isOwnerType && !isValidEmail(email))
      errors.email = intl.formatMessage({ id: 'Введите пожалуйста корректную почту' });
    // personal data end
    // juristic person start
    if (isOwnerType && !company_name) errors.company_name = true;
    if (isOwnerType && !company_city) errors.company_city = true;
    if (isOwnerType && !company_code) errors.company_code = true;
    if (isOwnerType && !company_address) errors.company_address = true;
    if (isOwnerType && !company_email) errors.company_email = true;
    else if (isOwnerType && !isValidEmail(company_email))
      errors.company_email = intl.formatMessage({ id: 'Введите пожалуйста корректную почту' });
    // juristic person end

    if (!confirm_btn) errors.confirm_btn = true;
    if (!car_mark) errors.car_mark = true;
    if (!car_model) errors.car_model = true;
    if (!deliveryTypeId) errors.delivery_type = true;
    if (!polis_start) errors.polis_start = true;
    if (!isValidVIN(car_body))
      errors.car_body = intl.formatMessage({
        id: 'Введите корректный номер кузова. Номер кузова состоит из 17-ти символов',
      });
    if (!car_volume) errors.car_volume = true;
    if (deliveryTypeId === 3 && !city) errors.city = true;
    if (!phone) errors.phone = true;
    else if (!isValidPhone(phone))
      errors.phone = intl.formatMessage({ id: 'Введите пожалуйста корректный телефон' });
    if (!car_number) errors.car_number = true;
    if (!car_year) errors.car_year = true;
    if (deliveryTypeId === 3 && !fio) errors.fio = true;
    if (deliveryTypeId === 3 && !point) errors.point = true;
    if (used_month.length !== 12 && monthCount + 1 !== used_month.length)
      errors.used_month = intl.formatMessage({
        id: 'Укажите больше месяцев для действия страховки',
      });

    return errors;
  },

  async handleSubmit(values, { props }) {
    // eslint-disable-next-line camelcase
    const {
      fetch,
      orderWithHash: { hash },
      selectedValues,
      user,
      toggleConfirmModal,
      setRedUrl,
    } = props;

    const isOwnerType = !!selectedValues.owner_type;
    const deliveryTypeId = values.delivery_type && +values.delivery_type.id;

    const requestData = {
      delivery_type_id: deliveryTypeId,
      payments_type_id: '1',
      success_url: `${protocol}//${hostname}${
        port ? `:${port}` : ''
      }/insurance/orders/?response_status=success`,
    };
    let fields = {
      ...values,
      car_mark: values.car_mark.id,
      car_model: values.car_model.id,
      polis_start: getFormattedDateFns(values.polis_start, 'dd-MM-yyyy'),
      car_year: getFormattedDateFns(values.car_year, 'yyyy'),
    };

    if (deliveryTypeId === NOVA_POSHTA_DELIVERY_ID) fields = { ...fields };

    if (isOwnerType) {
      fields = {
        ...fields,
        company_city: values.company_city.id ? values.company_city.id : values.company_city,
      };
    } else {
      fields = {
        ...fields,
        city_registration: values.city_registration.id
          ? values.city_registration.id
          : values.city_registration,
        date_of_birth: getFormattedDateFns(values.date_of_birth, 'dd-MM-yyyy'),
        document_type: values.document_type.id ? values.document_type.id : values.document_type,
        document_date: getFormattedDateFns(values.document_date, 'dd-MM-yyyy'),
      };
    }

    const delivery = values.epolils
      ? {}
      : {
          city: values.city.id ? values.city.id : values.city,
          point: values.point,
          fio: values.fio,
        };

    // remove empty fields && unneeded fields
    Object.keys(fields).forEach(key => !fields[key] && delete fields[key]);
    delete fields.delivery_type;
    delete fields.point;
    delete fields.fio;
    delete fields.city;

    requestData.fields = fields;
    if (deliveryTypeId === 3) requestData.delivery = delivery;

    const response = await fetch(API.POLIS.ORDERS_FILL(hash), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then(res => res.json())
      .then(result => {
        if (result.status && result.data) return result.data;
        return null;
      });

    const isVerifiedPhone = () =>
      !!user.phones.find(item => +item.number === +values.phone && item.is_verified);

    const redirectUrl = response && response.type === 'redirect' ? response.data : '';

    if ((!user || !user.id || !isVerifiedPhone()) && redirectUrl) {
      await sendOrderConfirmationCode(fetch, hash);
      setRedUrl(redirectUrl);
      toggleConfirmModal(true);
      return '';
    } else if (redirectUrl) {
      window.location.href = redirectUrl;
    }
    return null;
  },

  displayName: 'insuranceFormValidation',
};



// WEBPACK FOOTER //
// ./src/shared/helpers/insuranceFormValidation.js